import { render, staticRenderFns } from "./YearLog.vue?vue&type=template&id=48d2ec18&"
import script from "./YearLog.vue?vue&type=script&lang=js&"
export * from "./YearLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports